import { useState } from "react";
import BlogInner from "../BlogInner";
import DownloadNH from "../Common/DownloadNH";
import MainLayout from "../MainLayout";
import CommonHeader from "@/Common/CommonHeader/CommonHeader";
import ShareModal from "@/Component/Module/HolidayDetail/ShareModal";

export default function SingleBlogDetail({ postSlug, blogDetail, recentBlogs = [] }) {
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const openShareModal = () => {
    if (typeof window !== "undefined") {
      setShareUrl(window.location.href);
    }
    setShowShareModal(true);
  };

  if (!blogDetail) {
    return (
      <MainLayout hideHeader>
        <section className="standard-padding">
          <p className="nodata">Blog not found.</p>
        </section>
      </MainLayout>
    );
  }

  return (
    <div>
      <MainLayout hideHeader>
        <CommonHeader
          className="blogDetailArticleHero"
          classNameHead="blogCommonHeader"
          title={blogDetail.title}
          subtitle={blogDetail.shortDescription}
          buttonText=""
          buttonLink=""
          bgImage={blogDetail.bannerImage || "/images/Banner/blog-banner.jpg"}
          date={blogDetail.date}
          readTime={blogDetail.readTime}
          author={blogDetail.author?.name}
          authorSlug={blogDetail.author?.slug}
          isBlogPage={true}
          onShareClick={openShareModal}
        />
        <BlogInner
          postData={blogDetail}
          postSlug={postSlug}
          recentBlogs={recentBlogs}
          onShareClick={openShareModal}
        />
        <DownloadNH />
      </MainLayout>

      <ShareModal
        show={showShareModal}
        onHide={() => setShowShareModal(false)}
        shareUrl={shareUrl}
        title={blogDetail.title}
      />
    </div>
  );
}
